/* eslint-disable */
import { dbgMessages } from './dbgMessages.js';
// poor man's printf
export const dbgprintf = (s, ...args) => {
    const msg = sprintf(s, ...args);
    const debug = false;
    if(debug) {
        console.log('dbgprintf APP', msg);
    }
    const testErr = s.startsWith('Error: ') || s.startsWith('Exception') || args[ args.length - 1 ];
    const isError = typeof testErr === 'boolean' && testErr;
    const index = dbgMessages.add({
        topic: msg,
        // timestamp: new Date().toLocaleTimeString("de-DE", { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
        text: '',
        err: isError === true,
        caution: s.startsWith('Note: ') || s.startsWith('Caution: ')
    });
    
    if(window.app) { // app is global
        setTimeout(() => {
            window.app.dbgScrollToView();
        }, 10);
    }

    return index;
};

// eslint-disable-next-line no-unused-vars;
export const sprintf = (s, ...args) => {
    let i = 0;
    return s.replace(/%s|%d/g, function() {
        return args[ i++ ];
    });
};


let Utils = {};
export default Utils;
export { Utils };

Utils.tist = () => { return `TIST ${Date.now()}`; };

export function test() { return Date.now(); };

Utils.int2ip = (ipInt) => {
    return ((ipInt >>> 24) + '.' + (ipInt >> 16 & 255) + '.' + (ipInt >> 8 & 255) + '.' + (ipInt & 255));
};

Utils.ip2int = (ip) => {
    return ip.split('.').reduce(function(ipInt, octet) { return (ipInt << 8) + parseInt(octet, 10); }, 0) >>> 0;
};

Utils.toIP = (value) => {

    if(!value) {
        throw new Error('E_UNDEFINED_INTEGER');
    }

    const result = /\d+/.exec(value);

    if(!result) {
        throw new Error('E_INTEGER_NOT_FOUND');
    }

    value = result[ 0 ];

    return [
        (value >> 24) & 0xff,
        (value >> 16) & 0xff,
        (value >> 8) & 0xff,
        value & 0xff
    ].join('.');
};

Utils.toInt = (ip) => {

    if(!ip) {
        throw new Error('E_UNDEFINED_IP');
    }

    // if(!regexIP.test(ip)) {
    //     throw new Error('E_INVALID_IP');
    // }

    /*
      String value 189.170.79.173
      Integer	3182055341
      To convert an IP address to integer, break it into four octets.
      For example, the ip address you provided can be broken into
      First Octet:	189
      Second Octet:	170
      Third Octet:	79
      Fourth Octet:	173
      To calculate the decimal address from a dotted string, perform the following calculation.
      = (first octet * 256³) + (second octet * 256²) + (third octet * 256) + (fourth octet)
      =	(first octet * 16777216) + (second octet * 65536) + (third octet * 256) + (fourth octet)
      =	(189 * 16777216) + (170 * 65536) + (79 * 256) + (173)
      =	3182055341
      Reference http://www.aboutmyip.com/AboutMyXApp/IP2Integer.jsp
    */

    return ip.split('.').map((octet, index, array) => {
        return parseInt(octet) * Math.pow(256, (array.length - index - 1));
    }).reduce((prev, curr) => {
        return prev + curr;
    });

};


Utils.tagify = (value) => {
    if(!value) return [];
    if(Array.isArray(value)) {
        return value.map(t => t.toLowerCase().trim().replace(/\s/g, ""));
    };
    if(typeof value === 'string') {
        const arr = value.toLowerCase().split(',').filter(e => e.length).map(s => s.trim().replace(/[^a-z0-9]/gi, '')); //make lowercase , filter empty values and trim
        const tagSet = new Set(arr);  // remove duplicates
        return Array.from(tagSet); // convert array to comma separated string
        // return Array.from(tagSet).join(','); // convert array to comma separated string
    }
    return [];
};

Utils.hasUpperCase = (str) => /[A-Z]/.test(str);
Utils.getLowerCaseExtension = (s) => s.split('.').pop().trim().toLowerCase();
// Utils.getFilenameWithLowerCaseExtension = (s) => s.replace(/\.[a-z]+$/i, ext => ext.toLowerCase());
Utils.hasExtension = (s) => /\.[^\/\\]+$/.test(s);

Utils.getFilenameWithLowerCaseExtension = (s) => sanitizeUrlFilename(s);

Utils.getUrlParameter = function(name) {
    const nameA = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp("[\\?&]" + nameA + "=([^&#]*)");
    const results = regex.exec(location.search.replace(/\/$/, ""));
    return results === null
        ? null
        : decodeURIComponent(results[ 1 ].replace(/\+/g, " "));
};

Utils.throttle = function(fn, threshold = 250, context) {
    let last, timer;
    return function() {
        var ctx = context || this;
        var now = new Date().getTime(),
            args = arguments;
        if(last && now < last + threshold) {
            clearTimeout(timer);
            timer = setTimeout(function() {
                last = now;
                fn.apply(ctx, args);
            }, threshold);
        } else {
            last = now;
            fn.apply(ctx, args);
        }
    };
};

Utils.loadImageData = function(inUrl, callback) {
    let image = new Image();
    image.onload = function() {
        callback(image);
        image = null;
        // or to get raw image data
        // callback && callback(canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, ''));
    };
    image.src = inUrl;
};

Utils.loadImagePromise = url =>
    new Promise(resolve => {
        const img = new Image();
        img.onload = () => resolve({ url, status: 'ok', image: { h: img.naturalHeight, w: img.naturalWidth } });
        img.onerror = () => resolve({ url, status: 'error' });
        img.src = url;
    });

Utils.hashCode = (s) => {
    let hash = 0;
    for(var i = 0;i < s.length;i++) {
        hash = s.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
};

Utils.intToColor = (i) => {
    return (i & 0x00FFFFFF)
        .toString(16)
        .toUpperCase()
        .padStart(6, '0');
};

Utils.colorFromString = (s) => {
    return Utils.intToColor(Utils.hashCode(s));
};

Utils.parseJson = function(jsonString, _errCb) {
    if(typeof jsonString === 'object') return jsonString;
    try {
        const o = JSON.parse(jsonString);
        if(o && typeof o === 'object') {
            return o;
        }
    } catch(e) {
        if(_errCb) _errCb(e);
    }
    return false;
};

Utils.stripSpecials = (s) => s.replace(/[\s~`!@#$§%^&*(){}\[\];:"'<,>?\/\\|_+=-]/g, '');

Utils.stripNotAllowed = (s) => s.replace(/[^a-z0-9.-]/gi, '');

/* Array */

// Utils.removeFromArray = (arr, itm) => {
//     const index = arr.indexOf(itm);
//     if(index > -1) {
//         arr.splice(index, 1);
//     }
//     return index > -1;
// };

Utils.removeFromArray = (arr, item, removeAllOccurences = false) => {
    if(!Array.isArray(arr)) return false;
    let index = arr.indexOf(item);
    const changed = index > -1;
    if(removeAllOccurences) {
        while(index > -1) {
            arr.splice(index, 1);
            index = arr.indexOf(item);
        }
    } else {
        arr.splice(index, 1);
    }
    return changed;
};

// remove items from array mutating
Utils.removeFromArrayAllLoop = (arr, item) => {
    let changed = false;
    let j, i, len, elt;

    for(j = i = 0, len = arr.length;i < len;++i) {
        elt = arr[ i ];
        if(elt === item) {
            changed = true;
        } else {
            arr[ j++ ] = elt;
        }
    }

    arr.length = j;
    return changed;
};

Utils.readFileP = (file) => {
    return new Promise(function(resolve) {
        const reader = new FileReader();
        reader.onloadend = function(evt) {
            resolve(evt.target.result);
        };
        reader.onerror = function() {
            resolve("");
        };
        reader.readAsText(file);
    });
};

Utils.getFileFromFileEntryP = function(entry, path) {
    return new Promise((resolve, reject) => {
        entry.getFile(path, {}, resolve, reject);
    });
};
Utils.getDirectoryFromEntryP = function(entry, path) {
    return new Promise((resolve, reject) => {
        entry.getDirectory(path, {}, resolve, reject);
    });
};

Utils.getFileFromFileEntry = function(entry) {
    return new Promise((resolve) => {
        entry.file((file) => {
            // resolve(this.packageFile(file, entry));
            // resolve(file, entry);
            resolve({
                file,
                entry,
                objectURL: URL.createObjectURL(file),
                fullPath: `${entry.fullPath}`.slice(1)
            });

        });
    });
};


Utils.fetchFile = function(fileObj, responseType) {
    return new Promise(function(resolve) {
        if(!fileObj) {
            console.trace("-------- fetchFile ", fileObj);
        }
        const reader = new FileReader();

        reader.onloadend = (evt) => {
            if([ 'json' ].includes(responseType)) {
                let result;
                try {
                    result = JSON.parse(evt.target.result);
                } catch(error) {
                    console.log("Error parsing JSON", fileObj);
                    result = {};
                }
                resolve(result);
            } else {
                resolve(evt.target.result);
            }
        };
        reader.onerror = (evt) => {
            console.log("Error in Utils.fetchFile::reader", reader, evt);
        };
        if([ 'blob', 'arraybuffer' ].includes(responseType)) {
            reader.readAsArrayBuffer(fileObj);
        } else if([ 'text', 'json' ].includes(responseType)) {
            reader.readAsText(fileObj);
        } else {
            reader.readAsDataURL(fileObj);
        }
    }).catch(err => {
        console.log("ERROR while reading", fileObj, responseType);
    });
};

Utils.fetchXhr = function(path, type = 'arraybuffer') {
    return new Promise(function(resolve, reject) {
        const req = new XMLHttpRequest();
        req.withCredentials = true; // should be default anyway
        req.responseType = type;

        req.onload = () => {
            resolve({
                ok: true,
                [ type ]: () => Promise.resolve(req.response),
                // arrayBuffer: () => Promise.resolve(req.response),
                // blob: () => Promise.resolve(req.response)
            });
        };

        [ 'abort', 'error' ].forEach((evt) => { req.addEventListener(evt, (error) => { reject(error); }); });
        req.open('GET', path);
        req.send();
    });
};

Utils.pick6 = (o, keys) => keys.reduce((acc, key) => {
    acc[ key ] = o[ key ];
    return acc;
}, {});

Utils.pick = function(o, keys) {
    return keys.reduce((obj, key) => {
        if(o && o.hasOwnProperty(key)) {
            obj[ key ] = o[ key ];
        }
        return obj;
    }, {});
};

Utils.loadDataPromise = (url, loadAsJson = false) => {
    const css = `color:#ffee00`;
    const dbg = false ? console.log.bind(window.console, '[Utils]', css) : () => {};
    return new Promise(function(resolve) {
        let xhr = new XMLHttpRequest();
        if(loadAsJson) xhr.overrideMimeType('application/json');
        xhr.onreadystatechange = function() {
            if(xhr.readyState === 4) {
                let result;
                try {
                    result = loadAsJson === true ? JSON.parse(xhr.responseText) : xhr.responseText;
                } catch(error) {
                    dbg(error);
                    result = loadAsJson === true ? {} : '';
                }
                dbg("loadDataPromise::RESULT", url, result);
                resolve(result);
            }
        };
        xhr.onerror = function() {
            dbg('[Error]::ReadFile.reply was not JSON', xhr);
            resolve({});
        };
        xhr.open('GET', url, true);
        xhr.send(null);
    });
};


// Utils.uploadFile = (f) => {
//     var data = new FormData();
//     data.append("version", "1.6");
//     data.append("catalog", "streamDeckPlugin");
//     data.append("file", fileInput.files[ 0 ], "com.elgato.cpu.streamDeckPlugin");
//     var xhr = new XMLHttpRequest();
//     xhr.withCredentials = true;
//     xhr.addEventListener("readystatechange", function() {
//         if(this.readyState === 4) {
//             console.log(this.responseText);
//         }
//     });
//     xhr.open("POST", "https://appstoreconnect-staging.elgato.com/store/upload/streamDeckPlugin/");
//     xhr.setRequestHeader("Authorization", "Token 19f0d9e762b23573f79e10e0f31854c9a2ec9f0b");
//     xhr.send(data);
// };

// const fileObj = null;

// const uploadOptions = {
//     url: 'https://appstoreconnect-staging.elgato.com/store/upload/streamDeckPlugin/',
//     method: 'POST',
//     Authorization: 'Token 19f0d9e762b23573f79e10e0f31854c9a2ec9f0b',
//     data: {
//         version: '1.6',
//         catalog: 'streamDeckPlugin',
//         file: [ fileObj, "com.elgato.cpu.streamDeckPlugin" ]
//     }
// };

// const options = Object.assign({}, uploadOptions, {});

// Utils.uploadOptionsFn = (fileObj, token) => {
//     const uid = GetUUIDFromFilePath(fileObj.name);
//     const extension = EplFile_GetExtension(fileObj.name).substr(1); // strip leading '.'

//     // if(!['streamDeckPlugin', 'streamDeckIconPack'].includes(extension)) return null;
//     if(![ 'sdPlugin', 'sdIconPack' ].includes(extension)) return null;
//     return {
//         url: 'https://appstoreconnect-staging.elgato.com/store/upload/streamDeckPlugin/',
//         method: 'POST',
//         Authorization: `Token ${token}`,
//         data: {
//             version: '1.6',
//             catalog: extension,
//             file: [ fileObj, uid ]
//         }
//     };
// };

// Utils.uploadFileP = (options) => {
//     const css = `color:#99aaff`;
//     const dbg = true ? console.log.bind(window.console, '%c[Utils.uploadFileP]', css) : () => {};
//     dbg("Uploading", options);
//     return new Promise(function(resolve) {

//         const data = new FormData();
//         Object.entries(options.data).map(props => {
//             if(Array.isArray(props[ 1 ])) {
//                 data.append(props[ 0 ], ...props[ 1 ]);
//             } else {
//                 data.append(props[ 0 ], props[ 1 ]);
//             }
//         });

//         const xhr = new XMLHttpRequest();
//         xhr.onreadystatechange = function() {
//             if(xhr.readyState === 4) {
//                 let result;
//                 try {
//                     result = loadAsJson === true ? JSON.parse(xhr.responseText) : xhr.responseText;
//                 } catch(error) {
//                     dbg(error);
//                     result = loadAsJson === true ? {} : '';
//                 }
//                 dbg("RESULT", url, result);
//                 resolve(result);
//             }
//         };
//         xhr.onerror = function() {
//             dbg('[Error]::reply was not JSON', xhr);
//             resolve({});
//         };

//         xhr.open(options.method, options.url);
//         xhr.setRequestHeader("Authorization", options.Authorization);
//         xhr.send(data);

//     });
// };

const isDataURL = (s) => !!s.match(isDataURL.regex);
isDataURL.regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;
Utils.isDataURL = isDataURL;

// const isDataUrlMatches = (s) => s.match(/^data:image\/(png|jpg|tiff|jpeg|svg\+xml);base64,/);

const svgReplace = () => {
    return {
        '%3C': '<',
        '%3E': '>',
        '%23': '#'
    };
};

Utils.drawStringToCanvas = (text, size = 400, inCanvas) => {
    const canvas = inCanvas ? inCanvas : document.createElement('canvas');
    const tempCtx = canvas.getContext('2d');
    tempCtx.clearRect(0, 0, canvas.width, canvas.height);
    tempCtx.font = `${size}px Helvetica`;
    tempCtx.fontWeight = 'bold';
    tempCtx.lineHeight = size;
    tempCtx.fillStyle = '#d8d8d8';
    tempCtx.textAlign = 'center';
    tempCtx.textBaseline = 'middle';
    // tempCtx.fillText(`${text}`, canvas.width / 2, canvas.height / 2);

    // var text = 'All the world \'s a stage, and all the men and women merely players. They have their exits and their entrances; And one man in his time plays many parts.';
    // wrapText(tempCtx, text, 0, 0, 144);
    Utils.wrapText(tempCtx, text, canvas.width / 2, canvas.height / 2, canvas.width);


};

Utils.wrapText = (ctx, text, x = 0, y = 0, maxWidth = 144) => {
    const words = text.split(' ');
    let line = '';
    let metrics;

    for(let i = 0;i < words.length;i++) {
        let tmpStr = words[ i ];
        metrics = ctx.measureText(tmpStr);
        while(metrics.width > maxWidth) {
            tmpStr = tmpStr.substring(0, tmpStr.length - 1);
            metrics = ctx.measureText(tmpStr);
        }

        if(words[ i ] != tmpStr) {
            words.splice(i + 1, 0, words[ i ].substr(tmpStr.length));
            words[ i ] = tmpStr;
        }

        tmpStr = words.length > 1 ? `${line}${words[ i ]} ` : `${line}${words[ i ]}`;
        metrics = ctx.measureText(tmpStr);
        // console.log("len:", words.length, metrics);

        if(metrics.width > maxWidth && i > 0) {
            y -= ctx.lineHeight / 2;
            ctx.fillText(line, x, y);
            line = `${words[ i ]} `;
            y += ctx.lineHeight;
        }
        else {
            // console.log(tmpStr, metrics.width, x, maxWidth);
            // x = (metrics.width + x) / 2;
            line = tmpStr;
        }
    }
    ctx.fillText(line, x, y);
};

Utils.reverseString = (s) => {
    s.split("").reverse().join("");
};

Utils.getFontSize = (options = {}) => { //thx gifshot! :)
    // var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    /* needs {
        text: options.title, // the text to measure
        width: options.width || window.innerWidth, // maximum available width
        minFontSize: options.minFontSize, //minimum acceptable font size
    }
    */
    if(!document.body || options.resizeFont === false) {
        return options.fontSize;
    }

    var fontSize = parseInt(options.fontSize, 10) || 13;
    var minFontSize = parseInt(options.minFontSize, 10) || 6;
    var div = document.createElement('div');
    var span = document.createElement('span');

    div.setAttribute('width', options.width);
    div.appendChild(span);

    span.innerHTML = options.title || options.text || '';
    span.style.fontSize = fontSize + 'px';
    span.style.textIndent = '-9999px';
    span.style.visibility = 'hidden';

    document.body.appendChild(span);

    while((span.offsetWidth > options.width) && (fontSize >= minFontSize)) {
        span.style.fontSize = --fontSize + 'px';
    }

    document.body.removeChild(span);

    return fontSize; //+ 'px';
};

Utils.stringToHTML = function(html, all = false) {
    var template = document.createElement('template');
    template.innerHTML = html.trim();
    return all ? template.content : template.content.firstChild;
};

Utils.stringToHTMLDiv = function(html, className) {
    var template = document.createElement('div');
    if(className) template.classList.add(className);
    template.innerHTML = html.trim();
    return template;
};

Utils.debounce = function(func, wait = 100) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), wait);
    };
};

// since 2025-04-10
export function sanitizeUrlFilename(name) {
    const extIndex = name.lastIndexOf('.');
    const ext = extIndex !== -1 ? name.slice(extIndex) : '';
    const base = extIndex !== -1 ? name.slice(0, extIndex) : name;
    const cleanBase = base.replace(/[<>:"/\\|?*#&]/g, '_');
  
    // const cleanBase = base
    //   .normalize('NFD')                      // Decompose accented characters
    //   .replace(/[\u0300-\u036f]/g, '')      // Remove accents
    //   .replace(/ß/g, 'ss')
    //   .replace(/æ/g, 'ae')
    //   .replace(/œ/g, 'oe')
    //   .replace(/[^a-zA-Z0-9._+]+/g, '__')   // Replace unsafe chars/clusters with '__'
    //   .replace(/^__+|__+$/g, '')            // Trim leading/trailing __
    //   .toLowerCase();
    return cleanBase + ext.toLowerCase();  // as before - just lower case the extension
  }